<ng-container *ngIf="akitaEntity$ | async as collection">
	<!-- <app-quick-view-bar *ngIf="collection.quickViews"></app-quick-view-bar> -->

	<!-- Sidebar Filter -->
	<div class="template-container">
		<!-- Sidebar Filter Bar -->
		<app-filter-bar
			*ngIf="collection.currentTemplate.settings.filterSidebar && (akitaEntity$ | async)?.sidebarOpen"
			class="template-container-group-sidebar white-bg"
			[filters]="collection.filters"
			[queryParams]="collection.queryParams"
			[filterLayout]="'vertical'"
			(update)="updateQueryParams($event)"
		>
		</app-filter-bar>

		<div class="template-container-group-template" [class.scrollable-table]="scrollableTable">
			<!-- Horizontal Filter Bar -->
			<div class="toolbar-container">
				<app-filter-bar
					[filters]="collection.filters"
					[queryParams]="collection.queryParams"
					[showSidebarToggle]="collection.currentTemplate.settings.filterSidebar"
					(update)="updateQueryParams($event)"
					(toggleSidebar)="toggleSidebar()"
				></app-filter-bar>

				<!-- Columns -->
				<app-button-select
					*ngIf="['expandable-table', 'table'].includes(collection.currentTemplate?.slug) && collection.currentTemplate?.settings?.showColumnsSelectButton"
					class="ml-2"
					[options]="collection.currentTemplate.settings.columns"
					[currentValue]="collection.currentTemplate.settings.activeColumns"
					selectLayout="multiples"
					entityValue="id"
					buttonStyle="mat-mini-fab"
					buttonSize="button-big"
					iconName="view_column"
					[applyButton]="true"
					(applied)="setActiveColumns($event)"
				></app-button-select>
			</div>

			<ng-container [ngSwitch]="collection.currentTemplate?.slug" *ngIf="collection.entities?.length > 0; else noResults">
				<!-- Table -->
				<div [class.table-container]="scrollableTable">
					<app-table
						*ngSwitchCase="'table'"
						class="table"
						[scrollableTable]="scrollableTable"
						[showPaginator]="collection.showPaginator"
						[entities]="collection.entities"
						[template]="collection.currentTemplate"
						[page]="collection.queryParams.page"
						[limit]="collection.queryParams.limit"
						[totalResults]="collection.totalResults"
						[selectedEntities]="collection.selectedEntities"
						[loadingEntities]="collection.loadingEntities"
						(updatePagination)="updatePaginationState($event)"
						(updateSort)="updateSortState($event)"
						(action)="onActionEvent($event)"
						(clickOnCreate)="onCreate($event)"
						(clickOnLinkedColumn)="onLinked($event)"
					>
					</app-table>
				</div>
				<!-- Base Grid -->
				<app-grid
					*ngSwitchCase="'grid'"
					class="grid"
					[class.loading]="!collection.loaded && collection.entities.length > 0"
					[entities]="collection.entities"
					[template]="collection.currentTemplate"
					[page]="collection.queryParams.page"
					[limit]="collection.queryParams.limit"
					[totalResults]="collection.totalResults"
					[paginationMode]="collection.paginationMode"
					(updatePagination)="updatePaginationState($event)"
					(updateSort)="updateSortState($event)"
					(action)="onActionEvent($event)"
				>
					<ng-template let-item>
						<ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ $implicit: item }"> </ng-container>
					</ng-template>
				</app-grid>

				<!-- Base Grid -->
				<app-expandable-table
					*ngSwitchCase="'expandable-table'"
					class="table"
					[scrollableTable]="scrollableTable"
					[entities]="collection.entities"
					[template]="collection.currentTemplate"
					[page]="collection.queryParams.page"
					[limit]="collection.queryParams.limit"
					[totalResults]="collection.totalResults"
					[selectedEntities]="collection.selectedEntities"
					[loadingEntities]="collection.loadingEntities"
					(updatePagination)="updatePaginationState($event)"
					(updateSort)="updateSortState($event)"
					(action)="onActionEvent($event)"
					(clickOnCreate)="onCreate($event)"
					(clickOnLinkedColumn)="onLinked($event)"
				>
					<ng-template let-item>
						<ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ $implicit: item }"> </ng-container>
					</ng-template>
				</app-expandable-table>

				<!--  Carousel -->
				<app-carousel
					*ngSwitchCase="'carousel'"
					class="carousel"
					[entities]="collection.entities"
					[config]="collection.currentTemplate.settings.swiperOptions"
					[borderedSlide]="collection.currentTemplate.settings.borderedSlide"
				>
					<ng-template let-item>
						<ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ $implicit: item }"> </ng-container>
					</ng-template>
				</app-carousel>
			</ng-container>
		</div>
	</div>
</ng-container>

<ng-template #noResults>
	<div class="content-container compact">
		<div class="get-started-container">
			<div class="text-center" *ngIf="collectionQuery.getEntity(collection.id)?.loaded === true; else loading">
				<h4 class="primary-color"
					*ngIf="collection.currentTemplate?.settings?.noResults?.title">{{ collection.currentTemplate?.settings?.noResults?.title}}</h4>
				<h4 class="primary-color"
					*ngIf="!collection.currentTemplate?.settings?.noResults?.title" i18n="No Results Title@@collectionContainerNoResultsTitle">Couldn't find any results matching this criteria.</h4>
				<p class="primary-color"
				   *ngIf="collection.currentTemplate?.settings?.noResults?.description">
					{{
						collection.currentTemplate?.settings?.noResults?.description
					}}
				</p>
				<p *ngIf="!collection.currentTemplate?.settings?.noResults?.description"
				   class="primary-color"
				   i18n="No Results Description@@collectionContainerNoResultsDescription">Try using different filters to get a more results.
				</p>
				<button
					*ngIf="collection.currentTemplate?.settings?.noResults?.showCreateButton"
					mat-flat-button
					color="primary"
					id="create-new-project-button"
					(click)="onActionEvent(createAction)"
					class="mt-2"
				>
					<i class="uil-plus"></i>
					<ng-container i18n="Create New Button@@collectionContainerCreateNewButton">Create new</ng-container>
				</button>

				<div *ngIf="collection.currentTemplate?.settings?.noResults?.showResetFilters" class="actions">
					<button mat-flat-button color="primary" i18n="Reset Filters Button@@collectionContainerResetFiltersButton">Reset Filters</button>
				</div>
			</div>

			<ng-template #loading>
				<mat-spinner [diameter]="40" *ngIf="!hideLoadingSpinner"></mat-spinner>
			</ng-template>
		</div>
	</div>
</ng-template>
